import React from "react";
import Navbar from "./navbar";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import  './Resources/Actions.css';


export default function Balancereport(){
    const navigate = useNavigate();
    const[clist, setClist] = useState([]);
    const API_URL = process.env.REACT_APP_WEB_API_KEY;

    
    useEffect(()=> {
            
    fetch(API_URL+"api/Loan/GetBalance")
    .then(response => response.json())
    .then(data => {setClist(data)})
    },[]);

    const total = clist.reduce((tot,el)=>tot + el.LoanBalance ,0);

    return( 
    <>
        <div className="reportheader"> 
            Balance Report</div>
            <Navbar/>
            <div style={{marginBottom:"120px"}}>
            <div style ={{height:"50px",width:"100%",backgroundColor:"lightskyblue",borderStyle:"solid",borderColor:"white"}}> <div style={{float:"left", fontWeight:"bolder"}}>Loan Details </div>
             <div style={{textAlign:"right",marginRight:"5px", fontWeight:"bolder"}}>Balance</div> </div>
            {clist.map(cus=>{return(
            <div style ={{height:"50px",width:"100%",backgroundColor:"lightskyblue",borderStyle:"solid",borderColor:"white"}} ><div style={{float:"left"}}><li>{cus.CustomerName}</li>
             <li> ({cus.CustomerID}) : {cus.LoanDate.slice(8,10)}-{cus.LoanDate.slice(5,7)}-{cus.LoanDate.slice(0,4)} : {cus.LoanAmount}</li></div><div style={{textAlign:"right",marginRight:"10px",marginTop:"10px"}}><li>{cus.LoanBalance}</li></div> </div>)})} </div>
             <div style={{backgroundColor:"blue", color:"white", height:"30px", width:"100%", 
            paddingTop:"10px", bottom:"35px", position:"fixed", 
             fontFamily:"sans-serif",fontSize:"20px",textAlign:"center"}}>    
            {total}</div>
        
            <button type="button" className="backbutton" onClick={()=>{navigate('/loandetails')}} on>Back</button>
     </>
     )
}